import React from 'react';

import { PermissionCheck } from '@shared/Permissions';

export const withAccess = <P extends {}>(
  Component: React.ComponentType<P & AccessProps>
): React.ComponentType<P & AccessProps> => {
  const WithAccessComponent: React.FC<P & AccessProps> = props => {
    const { action } = props;
    const element = <Component {...props} />;

    return action ? (
      <PermissionCheck action={action}>{element}</PermissionCheck>
    ) : (
      element
    );
  };

  WithAccessComponent.displayName = `withAccess(${getDisplayName(Component)})`;

  return React.memo(WithAccessComponent) as typeof WithAccessComponent;
};

const getDisplayName = (WrappedComponent: React.ComponentType<any>) => {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
